import { gql } from 'graphql-tag'

export const fetchIntroductionLinks = gql`
  query FetchIntroductionLinks($stationId: ID!) {
    introductionLinks {
      id
      fileName
      href
      linkTags {
        id
        name
      }
    }
    favoriteIntroductionLinks(stationId: $stationId) {
      id
      fileName
      href
      linkTags {
        id
        name
      }
    }
  }
`

export const fetchAokIntroductionLinks = gql`
  query FetchAokIntroductionLinks($companyId: ID, $stationId: ID!) {
    aokIntroductionLinks(companyId: $companyId) {
      id
      fileName
      href
      linkTags {
        id
        name
      }
      company {
        id
        name
      }
    }
    favoriteIntroductionLinks(stationId: $stationId) {
      id
      fileName
      href
      linkTags {
        id
        name
      }
    }
  }
`

export const fetchFavoriteIntroductionLinks = gql`
  query FetchFavoriteIntroductionLinks($stationId: ID!) {
    favoriteIntroductionLinks(stationId: $stationId) {
      id
      fileName
      href
      linkTags {
        id
        name
      }
    }
  }
`

export const toggleFavoriteIntroductionLink = gql`
  mutation ToggleFavoriteIntroductionLink($stationId: ID!, $id: ID!) {
    favoriteIntroductionLink(stationId: $stationId, id: $id) {
      id
      fileName
      href
    }
  }
`
